import { Injectable } from '@angular/core'
import { Subject } from 'rxjs';

import { HsLanguageService } from 'hslayers-ng'

@Injectable({
  providedIn: 'root'
})
export class ChartsService {
  chartClicked: Subject<any> = new Subject();
  chartsGenerated: Subject<any> = new Subject();

  generatingCharts;

  constructor(public hsLangService: HsLanguageService) {

  }
}
